type JsPdfModule = typeof import('jspdf');
type JsPdfConstructor = JsPdfModule['jsPDF'];
type AutoTableModule = typeof import('jspdf-autotable');
type AutoTableDefault = AutoTableModule['default'];

export type JsPdfDocument = InstanceType<JsPdfConstructor>;
export type PdfDocumentOrientation = 'p' | 'portrait' | 'l' | 'landscape';
export type PdfDocumentUnit = 'pt' | 'px' | 'in' | 'mm' | 'cm' | 'ex' | 'em' | 'pc';
export type PdfDocumentFormat = string | number[];
export type PdfDocumentConstructorArgs =
    | [options?: PdfDocumentOptions]
    | [orientation?: PdfDocumentOrientation, unit?: PdfDocumentUnit, format?: PdfDocumentFormat, compressPdf?: boolean];
export type PdfAutoTableOptions = Parameters<AutoTableDefault>[1];
export type PdfAutoTableColor = import('jspdf-autotable').Color;

export interface PdfDocumentOptions {
    orientation?: PdfDocumentOrientation;
    unit?: PdfDocumentUnit;
    format?: PdfDocumentFormat;
    compress?: boolean;
    precision?: number;
    userUnit?: number;
    putOnlyUsedFonts?: boolean;
    filters?: string[];
    hotfixes?: string[];
}

let jsPdfConstructorPromise: Promise<JsPdfConstructor> | null = null;
let pdfAutoTablePromise: Promise<AutoTableDefault> | null = null;

function loadJsPdfConstructor(): Promise<JsPdfConstructor> {
    if (jsPdfConstructorPromise === null) {
        jsPdfConstructorPromise = import('jspdf').then(module => module.jsPDF);
    }

    return jsPdfConstructorPromise;
}

function loadPdfAutoTable(): Promise<AutoTableDefault> {
    if (pdfAutoTablePromise === null) {
        pdfAutoTablePromise = import('jspdf-autotable').then(module => module.default);
    }

    return pdfAutoTablePromise;
}

export async function createJsPdf(...args: PdfDocumentConstructorArgs): Promise<JsPdfDocument> {
    const JsPdf = await loadJsPdfConstructor();

    return new JsPdf(...(args as unknown as ConstructorParameters<JsPdfConstructor>));
}

export async function runPdfAutoTable(doc: JsPdfDocument, options: PdfAutoTableOptions): Promise<void> {
    const pdfAutoTable = await loadPdfAutoTable();

    pdfAutoTable(doc, options);
}
